import React, { useState, useEffect } from "react";
import DashboardCarousel from "../dashboard/dashboardCarousel/DashboardCarousel";
import { course } from "../dashboard/Dashboard";
import CreatedBootcampsCarousel from "./CreatedBootcampsCarousel/CreatedBootcampsCarousel";
import empty from "../../../Assets/Image/png/empty.png";
import { BtnPrimary } from "../../share/buttons/Btn";
import useFetch from "../../../Hooks/useFetch";

const CreatedBootcamps = () => {
    const [bootcamp, setBootcamp] = useState(true);
    const [courses, setCourses] = useState();
    const [allCourses, setAllCourses] = useState();
    const [sliderIndex, setSliderIndex] = useState();
    const [pagination, setPagination] = useState({
        current: 1,
    });

    useEffect(() => {
        if (sliderIndex >= 4) {
            setPagination({ ...pagination, current: 2 });
        }
        // if (sliderIndex < 4) {
        //     setPagination({ ...pagination, current: 1 });
        // }
    }, [sliderIndex]);

    useEffect(() => {
        allCourse.reFetch();
    }, [pagination]);

    const currentCourse = useFetch({
        method: "GET",
        url: "BootCampService/admin_current_bootcamp",
        noHeader: false,
        trigger: true,
        setter: setCourses,
    });
    const allCourse = useFetch({
        method: "GET",
        url: "BootCampService/admin_all_bootcamp",
        pagination: pagination,
        noHeader: false,
        trigger: true,
        setter: setAllCourses,
    });
    //TODO : pagination api doesnt work! (404 invalid page)

    return allCourses ? (
        <>
            <h4 className="text-[2rem] text-black-prim font-bold mb-16">
                دوره‌های جاری
            </h4>
            <div className="py-4 px-32 w-4/5 text-center mx-auto ">
                <DashboardCarousel
                    courses={courses?.results}
                    className="mb-20"
                />
            </div>
            <h4 className="text-[2rem] text-black-prim font-bold mb-16">
                همه دوره‌ها
            </h4>
            <div className=" w-full mx-auto CreatedBootcamps">
                <CreatedBootcampsCarousel
                    sliderIndex={sliderIndex}
                    setSliderIndex={setSliderIndex}
                    courses={allCourses?.results}
                />
            </div>
        </>
    ) : (
        <div>
            <p className=" text-[#77498F] text-[1.6rem] font-bold leading-[3.2rem] text-center mt-[4.8rem]">
                بوت کمپ های ساخته شده
            </p>
            <img
                src={empty}
                alt="empty"
                className=" mt-[4.7rem] max-w-[68.7rem] max-h-[54.4rem] text-center mx-auto"
            />
            <p className=" text-[#212121E5] text-[1.8rem] font-normal leading-[3.2rem] mt-[1.9rem] text-center">
                هنوز بوت کمپی نساخته اید!
            </p>
            <div className=" text-center mt-[2.1rem]">
                <BtnPrimary
                    text="+  ساخت بوت کمپ جدید"
                    className=" px-12 py-8 mt-6 mb-8"
                    // onClick={() => setShowMember(!showMember)}
                />
            </div>
        </div>
    );
};

export default CreatedBootcamps;
